import { 
  SimpleGrid, 
  Card, 
  CardBody, 
  Text, 
  Box,
  Avatar,
  HStack,
  VStack,
  useColorModeValue,
  Container
} from '@chakra-ui/react';

interface Speaker {
  speaker_id: string;
  speaker_name: string;
  speaker_desc: string;
  speaker_topics_and_views: string;
}

interface SpeakerDetailsProps {
  speakers: Speaker[];
}

export const SpeakerDetails = ({ speakers }: SpeakerDetailsProps) => {
  if (!speakers || speakers.length === 0) return null;

  const cardBg = useColorModeValue('white', 'gray.700');
  const cardHoverBg = useColorModeValue('gray.50', 'gray.600');
  const bioColor = useColorModeValue('gray.600', 'gray.300');

  return (
    <Container maxW="full" p={0}>
      <SimpleGrid 
        columns={{ base: 1, md: 2, lg: 3 }} 
        spacing={6}
        width="100%"
      >
        {speakers.map((speaker, index) => (
          <Card 
            key={speaker.speaker_id || index} 
            variant="outline"
            bg={cardBg}
            _hover={{ 
              transform: 'translateY(-2px)',
              bg: cardHoverBg,
              boxShadow: 'md',
              transition: 'all 0.2s ease-in-out'
            }}
            transition="all 0.2s ease-in-out"
            height="fit-content"
          >
            <CardBody>
              <VStack spacing={4} align="start">
                <HStack spacing={4} width="100%">
                  <Avatar 
                    name={speaker.speaker_name} 
                    size="lg"
                    bg="blue.500"
                  />
                  <Box flex={1}>
                    <Text fontWeight="bold" fontSize="lg" lineHeight="short">
                      {speaker.speaker_name || 'Unknown Speaker'}
                    </Text>
                  </Box>
                </HStack>

                {speaker.speaker_desc && (
                  <Text 
                    fontSize="sm" 
                    color={bioColor}
                    lineHeight="tall"
                  >
                    {speaker.speaker_desc}
                  </Text>
                )}

                {speaker.speaker_topics_and_views && (
                  <Box width="100%">
                    <Text fontSize="sm" fontWeight="medium" mb={2}>
                      Topics & Views:
                    </Text>
                    <Text fontSize="sm" color={bioColor}>
                      {speaker.speaker_topics_and_views}
                    </Text>
                  </Box>
                )}
              </VStack>
            </CardBody>
          </Card>
        ))}
      </SimpleGrid>
    </Container>
  );
}; 